export type DataTableDataDefinition<T> = ColumnGroup<T>[];

export interface ColumnGroup<T> {
  name: string;
  hideGroupName?: boolean;
  columns: Column<T>[];
  allowGroup?: boolean;
  mergeByField?: string;
}

export interface SubField {
  label?: string;
  fieldName: string;
  valueType: 'text' | 'date' | 'number';
  format?: string;
}

export interface ColumnHeaderToggle {
  checked: () => boolean;
  onChange: (checked: boolean) => void;
  tooltip?: string;
}

export interface Column<T> {
  caption: string;
  fieldName: string;
  valueType: 'text' | 'date' | 'number' | 'boolean' | 'status-icon';
  format?: string | undefined;
  index?: number;
  editable?: boolean | ((record: T) => boolean);
  infinityEditable?: boolean | ((record: T) => boolean);
  onInfinityChange?: (record: T, newValue: any) => void;
  defaultChecked?: boolean;
  fullColumnEdit?: boolean;
  lockable?: boolean;
  locked?: boolean;
  deletable?: boolean | ((record: T) => boolean);
  validator?: (value: any) => string | null;
  clickable?: boolean;
  icon?: string;
  onHeaderClick?: () => void;
  subFields?: SubField[];
  headerToggle?: ColumnHeaderToggle;
}

export interface CustomButtonDefinition<T> {
  icon: string;
  hint: string;
  onClick: (item: T) => {};
  editModeVisiblity?: EditModeVisibility;
  isVisible?: (item: T) => boolean;
  title?: string;
}

export type EditModeVisibility =
  | 'always-visible'
  | 'hide-when-editing'
  | 'only-edit-mode';
